<template>
  <div class="network-error h-center-align">
    <h1>Uh-Oh!</h1>
    <h3>
      It looks like you're experiencing some network issues, <a href="#" @click="$router.go(-1)">click here</a> to try
      again.
    </h3>
  </div>
</template>

<script>
  export default {
    name: 'NetworkError'
  };
</script>

<style scoped lang="scss">

</style>
